<template>
    <div style="padding-top: 80px">
        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>
        </v-row>
        <v-card elevation="6" class="base-card-container pa-0 mt-4" v-if="permisoLevantar">
            <v-card-title class="pa-5 pb-3 primary">
                <v-icon class="pr-4" :color="'#FFFFFF'">mdi-thumb-down</v-icon>
                <p style="color: white;">Levantar Queja</p>

            </v-card-title>
            <v-form ref="form" v-model="validForm" lazy-validation>
                <v-card-text>
                    <v-row justify="center">
                        <v-col cols="12" md="8">
                            <v-row>
                                <v-col md="12">
                                    <center>
                                        <v-radio-group v-model="datos.tipoQueja">
                                            <v-row>
                                                <v-col sm="6" md="6">
                                                    <v-radio label="Externa" value="1" @change="cambio()"></v-radio>

                                                </v-col>
                                                <v-col sm="6" md="6">
                                                    <v-radio label="Interna" value="2" @change="cambio()"></v-radio>

                                                </v-col>
                                            </v-row>
                                        </v-radio-group>
                                    </center>

                                    <v-row style="margin-bottom: 0px !important; height: 70px;">
                                        <v-col sm="8" md="8">
                                            <div class="mt-2">
                                                <span style="font-weight: bold;">No.Reporte</span>
                                                <v-text-field v-model="datos.nrreporte"
                                                              outlined
                                                              dense
                                                              :rules="rulesInputs2()"
                                                              maxlength="10"
                                                              @keypress="ruleNumber($event,datos.nrreporte)">
                                                    
                                                </v-text-field>
                                            </div>

                                        </v-col>
                                        <v-col sm="4" md="4">
                                            <div class="mt-2">
                                                <span style="font-weight: bold;">Índice</span>
                                                <v-text-field v-model="datos.svindice"
                                                              outlined
                                                              dense
                                                              :rules="rulesInputs2()"
                                                              maxlength="2"
                                                              @keypress="ruleNumber($event,datos.svindice)"></v-text-field>
                                            </div>

                                        </v-col>

                                    </v-row>
                                    <v-row v-if="errorRepIndice" style="margin-bottom: 0px !important; height: 30px;">
                                        <v-col cols="12">
                                            <span class='spanError' style="color:red;font-size:13px">El número de reporte o índice no existen</span>
                                        </v-col>
                                    </v-row>
                                    <v-row style="margin-bottom: 0px !important; height: 70px;">
                                        <v-col cols="12">
                                            <div class="mt-2">
                                                <span style="font-weight: bold;">Nombre</span>
                                                <v-text-field v-model="datos.nombre"
                                                              outlined
                                                              dense
                                                              :rules="rulesInputsText"
                                                              v-on:blur="datos.nombre = datos.nombre != null ? datos.nombre.trim() : null"
                                                              maxlength="50"></v-text-field>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-row style="margin-bottom: 0px !important; height: 70px;">
                                        <v-col>
                                            <div class="mt-2">
                                                <span style="font-weight: bold;">E-mail</span>
                                                <v-text-field v-model="datos.email"
                                                              outlined dense
                                                              :rules="rulesInputsEmail(datos.email)"></v-text-field>
                                            </div>
                                        </v-col>
                                        <v-col v-if="datos.tipoQueja==1" sm="4" md="4">
                                            <div class="mt-2">
                                                <span style="font-weight: bold;">Folio Externo</span>
                                                <v-text-field v-model="datos.folioex"
                                                              outlined
                                                              dense
                                                              maxlength="30"
                                                              ></v-text-field>
                                            </div>

                                        </v-col>

                                    </v-row>
                                    <v-row v-if="errorEmail" style="margin-bottom: 0px !important; height: 30px;">
                                        <v-col cols="12">
                                            <span class='spanError' style="color:red;font-size:13px">Inserte al menos un correo o número de teléfono válido</span>
                                        </v-col>
                                    </v-row>
                                    <v-row style="margin-bottom: 0px !important; height: 70px;">
                                        <v-col>
                                            <div class="mt-2">
                                                <span style="font-weight: bold;">Número</span>
                                                <vue-tel-input-vuetify v-model="datos.telefono"
                                                                       :error-messages="errorTelf" @input="onInput" outlined label=""
                                                                       autocomplete="off" loading="true" max="10" required placeholder=""
                                                                       :defaultCountry="pais" validCharactersOnly="false"
                                                                       v-on:country-changed="countryChanged" dense></vue-tel-input-vuetify>
                                            </div>

                                        </v-col>
                                        <v-col>
                                            <div class="mt-2">
                                                <span style="font-weight: bold;">Departamento</span>
                                                <v-select outlined
                                                          dense
                                                          :items="deptosArray"
                                                          v-model="datos.departamento"
                                                          no-data-text="Sin datos"
                                                          item-text="dpnombre"
                                                          item-value="dpid"
                                                          placeholder="Seleccione una opción"
                                                          :rules="ruleSelect">

                                                </v-select>
                                            </div>

                                        </v-col>
                                    </v-row>


                                    <v-row style="margin-bottom: 0px !important; height: 70px;">
                                        <v-col sm="6" md="6">
                                            <div class="mt-2">
                                                <span style="font-weight: bold;">Concepto</span>
                                                <v-select outlined
                                                          dense
                                                          :items="conceptosArray"
                                                          v-model="datos.concepto"
                                                          no-data-text="Seleccione el Departamento"
                                                          item-text="qjconcepto"
                                                          item-value="qjid"
                                                          placeholder="Seleccione una opción"
                                                          :rules="ruleSelect">

                                                </v-select>
                                            </div>
                                        </v-col>
                                        <v-col sm="6" md="6">
                                            <div class="mt-2">
                                                <span style="font-weight: bold;">Origen de queja</span>
                                                <v-select outlined
                                                          dense
                                                          :items="fuentesArray"
                                                          v-model="datos.idFuente"
                                                          no-data-text="Sin datos"
                                                          item-text="ctfConcepto"
                                                          item-value="ctfid"
                                                          placeholder="Seleccione una opción"
                                                          :rules="ruleSelect">
                                                </v-select>
                                            </div>
                                        </v-col>
                                    </v-row>
                                    <v-row>
                                        <v-col cols="12">
                                            <div class="mt-2">
                                                <span style="font-weight: bold;">Descripción</span>
                                                <v-textarea @input="uppercase('descripcion')"
                                                            v-on:blur="datos.descripcion = datos.descripcion != null ? datos.descripcion.trim() : null"
                                                            :counter="500"
                                                            :rules="rulestextarea"
                                                            outlined rows="3"
                                                            v-model="datos.descripcion"></v-textarea>
                                            </div>

                                        </v-col>
                                    </v-row>
                                </v-col>

                            </v-row>



                        </v-col>
                    </v-row>


                    <v-col md="12">
                        <v-row justify="center">
                            <v-btn dark
                                   class="ma-2"
                                   color="primary"
                                   title="Guardar"
                                   @click="guardar()"
                                   :disabled="disabledSave">
                                <span style='color: white;'>Guardar</span>
                            </v-btn>
                            <v-btn dark
                                   class="ma-2"
                                   color="#FF4081"
                                   title="Cancelar"
                                   @click="cancelar()"
                                   :disabled="disabledSave">
                                <span style='color: white;'>Cancelar</span>
                            </v-btn>
                        </v-row>
                    </v-col>


                </v-card-text>
            </v-form>
        </v-card>
    </div>
</template>




<script>
    import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
    import Quejas from "@/services/Quejas/Quejas.service.js";
    import { mapActions, mapMutations, mapState, mapGetters } from "vuex";
    import Menu from '@/components/pages/Quejas/Menu/Menu.vue';
    export default {
        title() {
            return this.$route.meta.title
        },
        components: {
            Menu,
            DataTable,
        },
        data() {
            return {
                disabledSave: false,
                validForm: true,
                pais: 'MX',
                prefijo: null,
                errorTelf: [],
                phone: {
                    number: null,
                    valid: false,
                    country: null
                },
                deptosArray: [],
                fuentesArray: [],
                conceptosArray: [],
                errorRepIndice: false,
                errorEmail: false,
                datos: {
                    tipoQueja: '1',
                    nrreporte: null,
                    svindice: null,
                    nombre: null,
                    email: null,
                    telefono: null,
                    telefono2: null,
                    departamento: null,
                    concepto: null,
                    descripcion: null,
                    folioex: null,
                    idFuente: null
                },
                rulesInputs: [(v) => !!v || "Campo requerido"],
                rulesInputsText: [//v => !!v || 'Campo requerido',
                    v => {
                        if (v == null || v == '') {
                            return "Campo requerido"
                        }
                        else {
                            if (v.length < 12) {
                                return 'Mínimo 12 Carácteres'
                            }
                            else
                                return true
                        }
                    },
                ],
                ruleSelect: [(v) => !!v || "Campo requerido"],
                rulestextarea: [//v => !!v || 'Campo requerido',
                    v => {
                        if (v == null || v == '') {
                            return "Campo requerido"
                        }
                        else {
                            if (v.length < 12) {
                                return 'Mínimo 12 Carácteres'
                            }
                            else if (v.length > 500) {
                                return 'Máximo 500 Carácteres'
                            }
                            else
                                return true
                        }
                    },
                ],
                permisoLevantar: false

            }
        },
        computed: {
            ...mapState({ drawer: (state) => state.drawer }),
            ...mapState(["domain", "informationPage"]),
        },
        watch: {
            'datos.tipoQueja'(val) {
                this.pais = 'MX';
                this.prefijo = null;
                this.conceptosArray = [];
                Quejas.obtenerDepartamento(this);
                this.datos.nrreporte = null;
                this.datos.svindice = null;
                this.datos.nombre = null;
                this.datos.email = null;
                this.datos.telefono = null;
                this.datos.telefono2 = null;
                this.datos.departamento = null;
                this.datos.concepto = null;
                this.datos.idFuente = null;
                this.datos.descripcion = null;
                this.errorRepIndice = false;
                this.errorEmail = false;
                this.phone = {
                    number: null,
                    valid: false,
                    country: null
                };
                setTimeout(() => {
                    this.errorTelf = [];
                }, 100);
                this.$refs.form.resetValidation();

            },
            'datos.nrreporte'(val) {
                this.errorRepIndice = false;
            },
            'datos.svindice'(val) {
                this.errorRepIndice = false;
            },
            'datos.departamento'(val) {
                Quejas.obtenerConcepto(val,this);
            },
            'datos.email'(val) {
                this.errorEmail = false;
            },
            'datos.telefono'(val) {
                this.errorEmail = false;
            },
        },
        methods: {
            async guardar() {

                this.disabledSave = true;
                this.$refs.form.validate();
                let cont = 0;
                

                if ((this.datos.nrreporte != null && this.datos.nrreporte != '') && (this.datos.svindice != null && this.datos.svindice != '') ) {

                    await Quejas.validarExisteReporte(this).then(response => {
                        if (response==0) {
                            this.errorRepIndice = true;
                            cont++;
                        }
                    });

                    
                }
                

                if ((this.datos.email == null || this.datos.email == '') && (this.datos.telefono == null || this.datos.telefono == '')) {
                    this.errorEmail = true;
                    cont++;
                }

                if ((this.datos.telefono != null && this.datos.telefono != '')) {
                    if (!this.phone.valid) {
                        cont++;
                        this.errorTelf.push("Teléfono Inválido");
                    }
                }
                if (this.$refs.form.validate() && cont == 0) {

                    this.$swal({
                        position: "center",
                        title: "Guardando...",
                        html: "Espere un momento, por favor",
                        allowEscapeKey: false,
                        allowOutsideClick: false,
                        didOpen: () => {
                            this.$swal.showLoading();
                        },
                    });

                    await Quejas.guardarQueja(this).then(response => {

                        setTimeout(() => {
                            this.$swal.close();


                            this.$swal({
                                position: 'center',
                                icon: 'success',
                                title: 'Éxito',
                                text: 'Se guardó correctamente la Queja con el No. ' + response,
                                showConfirmButton: true,
                                allowOutsideClick: false,
                            }).then((result) => {
                                if (result.isConfirmed) {
                                    window.location.reload();
                                }
                            });


                        },1000);

                    });
                }
                else {
                    this.disabledSave = false;
                }


            },
            cancelar() {
                this.pais = 'MX';
                this.prefijo = null;
                this.conceptosArray = [];
                this.datos = {
                    tipoQueja: '1',
                    nrreporte: null,
                    svindice: null,
                    nombre: null,
                    email: null,
                    telefono: null,
                    telefono2: null,
                    departamento: null,
                    concepto: null,
                    descripcion: null

                };
                this.errorRepIndice = false;
                this.errorEmail = false;
                this.phone = {
                    number: null,
                    valid: false,
                    country: null
                };
                setTimeout(() => {
                    this.errorTelf = [];
                }, 100);
                //this.$refs.form.reset();
                this.$refs.form.resetValidation();
            },
            cambio(){
                if (this.datos.tipoQueja=='2') {
                    this.datos.folioex=null;
                }
            },
            rulesInputs2() {
                var resultRules = [];
                if (this.datos.tipoQueja=='1') {
                    resultRules.push((v) => {
                        if (v == null || v == '') {
                            return "Campo requerido";
                        } else return true;
                    });
                }
                if (this.datos.tipoQueja == '2') {
                    if ((this.datos.nrreporte != null && this.datos.nrreporte != '') || (this.datos.svindice != null && this.datos.svindice != '')) {

                        resultRules.push((v) => {
                            if (v == null || v == '') {
                                return "Campo requerido";
                            } else return true;
                        });
                    }
                }
                
                return resultRules;
            },
            ruleNumber: function ($event, value) {

                if (value == '' || value == null) {
                    if ($event.charCode >= 49 && $event.charCode <= 57) {
                        return true;
                    }
                    else {
                        $event.preventDefault();
                    }
                }
                else {
                    if (($event.charCode >= 48 && $event.charCode <= 57)) {
                        return true;
                    }
                    else {
                        $event.preventDefault();
                    }

                }
            },
            rulesInputsEmail(value) {
                
                var resultRules = [];
                if (value == null || value == '') {
                    return resultRules
                }
                if (/^([\w+-.%]+@[\w.-]+\.[A-Za-z]{2,4})(;[\w+-.%]+@[\w.-]+\.[A-Za-z]{2,4})*$/i.test(value)) return resultRules
                resultRules.push('Correo invalido');
                return resultRules
            },
            countryChanged(country) {
                this.prefijo = country.dialCode;
                this.pais = country.iso2;
            },
            onInput(formattedNumber, { number, valid, country }) {
                this.datos.telefono2 = null;
                if (number.input == number.national) {
                    this.errorTelf = [];
                    this.phone.number = number.national;
                    this.phone.valid = valid;
                    this.phone.country = country && country.name;
                    this.datos.telefono2 = number.national.replace(/[^0-9]+/g, "");
                }
                else {
                    if (number.input == '') {
                            this.errorTelf = [];
                        this.phone.number = null;
                        this.phone.valid = false;
                        this.phone.country = null;
                    }
                    else {
                        this.errorTelf.push("Teléfono Inválido");
                        this.phone.number = number.national;
                        this.phone.valid = false;
                        this.phone.country = country && country.name;
                    }

                       
                    
                }

            },
            uppercase(input) {
                if (input == "descripcion") {
                    if (this.datos.d3descdanos != '' && this.datos.d3descdanos != null) {
                        this.datos.d3descdanos = this.datos.d3descdanos.toUpperCase();
                    }
                }
            },
        },
        async mounted() {

            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", "208"//modulo de quejas
            ).then((response) => {
                if (response.data.length == 0) {
                    this.$router.push({ name: `NoAutorizado` }).catch(error => error);
                    return
                }
            });
            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", "212"
            ).then((response) => {
                if (response.data.length > 0) {
                    this.permisoLevantar = true;
                }
            });

            Quejas.obtenerDepartamento(this);
            Quejas.obtenerFuenteQueja(this);
        }
    }

</script>